($ => {

	$('.accordion-section').accordion();

	$('.accordion-section-title').on( 'click keypress', event => {
		if( event.which === 13 || event.type === 'click' ) {
			$('.accordion-section-content').attr( 'tabindex', '' );
			$( event.target ).siblings('.accordion-section-content').attr( 'tabindex', '0' ).focus();
		}
	});

})(jQuery);


// WEBPACK FOOTER //
// ./js/components/accordion.js